import { apiFetch } from "./legacy-integration-service";

//#region Type definitions

export type QueryCurrencyResponse = QueryCurrencyResponseItem[];

export type QueryCurrencyResponseItem = {
    currencyCode: string;
    description: string;
};

//#endregion

export async function queryCurrencies(): Promise<QueryCurrencyResponse> {
    return (
        (await apiFetch<QueryCurrencyResponse>(`/currencies`, {
            headers: { "Content-Type": "application/json" },
        })) ?? []
    );
}
